module.exports = __webpack_public_path__ + "media/images/patent/y_11-911ab28f2a490de90c00c723c20d2943.jpg";